import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

@Injectable({
  providedIn: 'root',
})
export class LoggingService {
  constructor(@Inject(PLATFORM_ID) private platformId: object) {}

  public getSessionId(): string | null {
    if (typeof window !== 'undefined' && window.localStorage) {
      return localStorage.getItem('sessionId') || 'unknown';
    }

    return null;
  }

  log(
    level: string,
    severity: string,
    screenName: string,
    source: string,
    message: string,
    data?: object,
    stackTrace?: string,
  ) {
    const logEntry = {
      timestamp: new Date().toISOString(),
      level,
      severity,
      sessionId: this.getSessionId(), // Example to get session ID
      screenName: screenName || 'N/A',
      source,
      deviceInfo: this.getDeviceInfo(), // Function to get device info
      data: data || {},
      message,
      stackTrace: stackTrace || '',
    };

    this.sendToExternalTool(logEntry); // Optional: Integrate with external tools like Sentry or ELK
  }

  private getDeviceInfo() {
    // Check if the code is running in the browser environment
    if (isPlatformBrowser(this.platformId)) {
      return {
        browser: navigator.userAgent, // Browser's user agent string
        platform: navigator.platform, // Browser's platform (OS)
      };
    }

    return {
      browser: 'Unknown Browser (SSR or Non-Browser Environment)',
      platform: 'Unknown Platform',
    };
  }

  private sendToExternalTool(logEntry: object) {
    if (isPlatformBrowser(this.platformId)) {
      const logData = JSON.stringify(logEntry); // Convert object to string
      localStorage.setItem('log_entry_data', logData);
      // Optional: Implement logic to send log to Sentry, ELK, or another external tool
    } else {
      // Handle logging in SSR environment if needed, or skip
    }
  }
}
